import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import AdminPanel from './AdminPanel';
import BloodWorldPrivacyPolicy from './BloodWorldPrivacyPolicy';
import SealChatPrivacyPolicy from './SealChatPrivacyPolicy';
import Support from './Support';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/al-admin" element={<AdminPanel />} />
        <Route path="/bloodword/privacypolicy" element={<BloodWorldPrivacyPolicy />} />
        <Route path="/sealchat/privacy" element={<SealChatPrivacyPolicy />} />
        <Route path="/support" element={<Support />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
